import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" }
const _hoisted_3 = { class: "bg-gray-800 rounded-lg p-6 border-l-4 border-blue-500" }
const _hoisted_4 = { class: "flex items-center space-x-6" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-2xl font-bold text-green-400" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-2xl font-bold text-red-400" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-2xl font-bold text-blue-400" }
const _hoisted_11 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_12 = { class: "text-sm text-gray-400 mb-1" }
const _hoisted_13 = { class: "w-full bg-gray-700 rounded-full h-2" }
const _hoisted_14 = { class: "bg-gray-800 rounded-lg p-6 border-l-4 border-green-500" }
const _hoisted_15 = { class: "flex items-center space-x-6" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-2xl font-bold text-green-400" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-2xl font-bold text-red-400" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-2xl font-bold text-green-400" }
const _hoisted_22 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_23 = { class: "text-sm text-gray-400 mb-1" }
const _hoisted_24 = { class: "w-full bg-gray-700 rounded-full h-2" }
const _hoisted_25 = { class: "flex flex-wrap gap-3 mb-6" }
const _hoisted_26 = { class: "inline-flex items-center ml-3 space-x-2" }
const _hoisted_27 = { class: "inline-flex items-center ml-3 space-x-2" }
const _hoisted_28 = { class: "flex items-center" }
const _hoisted_29 = { class: "text-sm text-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.stats)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"flex items-center justify-between mb-4\"><h3 class=\"text-lg font-semibold text-white\">Kao prodavac</h3><div class=\"bg-blue-500 rounded-full p-2\"><svg class=\"w-5 h-5 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M16 11V7a4 4 0 00-8 0v4M8 11v6a4 4 0 008 0v-6M8 11h8\"></path></svg></div></div>", 1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.stats.seller.likes), 1),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-sm text-gray-400" }, "Pozitivne", -1))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.stats.seller.dislikes), 1),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-sm text-gray-400" }, "Negativne", -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.sellerTotal), 1),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-sm text-gray-400" }, "Ukupno", -1))
              ])
            ]),
            (_ctx.sellerTotal > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, " Pozitivnost: " + _toDisplayString(_ctx.sellerPositivePercentage) + "% ", 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "bg-green-500 h-2 rounded-full transition-all duration-300",
                      style: _normalizeStyle({ width: _ctx.sellerPositivePercentage + '%' })
                    }, null, 4)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"flex items-center justify-between mb-4\"><h3 class=\"text-lg font-semibold text-white\">Kao kupac</h3><div class=\"bg-green-500 rounded-full p-2\"><svg class=\"w-5 h-5 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 11-4 0v-6m4 0V9a2 2 0 10-4 0v4.01\"></path></svg></div></div>", 1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.stats.buyer.likes), 1),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-sm text-gray-400" }, "Pozitivne", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.stats.buyer.dislikes), 1),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-sm text-gray-400" }, "Negativne", -1))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.buyerTotal), 1),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-sm text-gray-400" }, "Ukupno", -1))
              ])
            ]),
            (_ctx.buyerTotal > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, " Pozitivnost: " + _toDisplayString(_ctx.buyerPositivePercentage) + "% ", 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", {
                      class: "bg-green-500 h-2 rounded-full transition-all duration-300",
                      style: _normalizeStyle({ width: _ctx.buyerPositivePercentage + '%' })
                    }, null, 4)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleRoleChange('seller'))),
            class: _normalizeClass(["px-5 py-3 rounded-lg text-white font-medium transition-colors flex items-center", 
          _ctx.userRole === 'seller'
            ? 'bg-blue-600 hover:bg-blue-500 shadow-lg'
            : 'bg-gray-700 hover:bg-gray-600'
        ])
          }, [
            _cache[17] || (_cache[17] = _createElementVNode("span", null, "Kao prodavac", -1)),
            _createElementVNode("span", _hoisted_26, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleFilterChange('seller', 'positive')), ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded cursor-pointer transition-colors", {
              'bg-green-800 text-green-200':
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'positive',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'positive'
              ),
            }])
              }, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mr-1" }, "👍", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.seller.likes), 1)
              ], 2),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleFilterChange('seller', 'negative')), ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded cursor-pointer transition-colors", {
              'bg-red-800 text-red-200':
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'negative',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'negative'
              ),
            }])
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mr-1" }, "👎", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.seller.dislikes), 1)
              ], 2)
            ])
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleRoleChange('buyer'))),
            class: _normalizeClass(["px-5 py-3 rounded-lg text-white font-medium transition-colors flex items-center", 
          _ctx.userRole === 'buyer'
            ? 'bg-green-600 hover:bg-green-500 shadow-lg'
            : 'bg-gray-700 hover:bg-gray-600'
        ])
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("span", null, "Kao kupac", -1)),
            _createElementVNode("span", _hoisted_27, [
              _createElementVNode("span", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleFilterChange('buyer', 'positive')), ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded cursor-pointer transition-colors", {
              'bg-green-800 text-green-200':
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'positive',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'positive'
              ),
            }])
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "mr-1" }, "👍", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.buyer.likes), 1)
              ], 2),
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleFilterChange('buyer', 'negative')), ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded cursor-pointer transition-colors", {
              'bg-red-800 text-red-200':
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'negative',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'negative'
              ),
            }])
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "mr-1" }, "👎", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.buyer.dislikes), 1)
              ], 2)
            ])
          ], 2),
          (_ctx.activeFilter !== 'all')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('change-filter', 'all'))),
                class: "px-5 py-3 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white font-medium transition-colors"
              }, " Prikaži sve ocene "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.activeFilter !== 'all')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["mb-6 px-4 py-3 bg-gray-800 rounded-lg border-l-4", {
        'border-green-500': _ctx.activeFilter === 'positive',
        'border-red-500': _ctx.activeFilter === 'negative',
      }])
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-2 h-2 rounded-full mr-3", {
            'bg-green-500': _ctx.activeFilter === 'positive',
            'bg-red-500': _ctx.activeFilter === 'negative',
          }])
                }, null, 2),
                _createElementVNode("span", _hoisted_29, [
                  _cache[21] || (_cache[21] = _createTextVNode(" Prikazuju se samo ")),
                  _createElementVNode("span", {
                    class: _normalizeClass(["font-medium", {
              'text-green-400': _ctx.activeFilter === 'positive',
              'text-red-400': _ctx.activeFilter === 'negative',
            }])
                  }, _toDisplayString(_ctx.activeFilter === 'positive' ? 'pozitivne' : 'negativne'), 3),
                  _cache[22] || (_cache[22] = _createTextVNode(" ocene kao ")),
                  _createElementVNode("span", {
                    class: _normalizeClass(["font-medium", {
              'text-blue-400': _ctx.userRole === 'seller',
              'text-green-400': _ctx.userRole === 'buyer',
            }])
                  }, _toDisplayString(_ctx.userRole === 'seller' ? 'prodavac' : 'kupac'), 3)
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}